<div class="meter-download-wizard">
  <section class="header">
    <div class="header-text">
      <span class="title">{{ 'module.shared.excelDownloadWizard.genericHeaderText' | translate }}</span>
    </div>
    <button class="btn btn-primary btn-close" (click)="closeWizard()">
      <img class="x-icon" alt="close-icon" src="../../../../assets/icons/close-icon-gray.svg" />
    </button>
  </section>

  <section class="body">
    <div class="sub-title">
      <span class="text">{{ title }}</span>
    </div>

    <app-meter-selection
      *ngIf="currentStep === 0"
      (title)="getTitle($event)"
      (meterSelection)="storeMeterSelection($event)"
      (nextButtonStatus)="getNextButtonState($event)"
      [filter]="filter"
    >
    </app-meter-selection>

    <app-granularity-selection
      *ngIf="currentStep === 1"
      (title)="getTitle($event)"
      (granularity)="storeSelectedGranularity($event)"
      (nextButtonStatus)="getNextButtonState($event)"
      [filter]="filter"
    >
    </app-granularity-selection>

    <app-meter-list-selection
      *ngIf="currentStep === 2"
      (title)="getTitle($event)"
      (checkMeter$)="onCheckMeter($event)"
      [isCurrent]="filter.meterSelection === 'current' ? true : false"
      [granularity]="filter.granularity"
      [checkedMeter]="filter.meterData"
      (nextButtonStatus)="getNextButtonState($event)"
    >
    </app-meter-list-selection>

    <app-date-selection
      *ngIf="currentStep === 3"
      (title)="getTitle($event)"
      (nextButtonStatus)="getNextButtonState($event)"
      [startDate]="filter.dateRange.startDate"
      [endDate]="filter.dateRange.endDate"
      [filter]="filter"
    >
    </app-date-selection>

    <app-file-extension-selection
      *ngIf="currentStep === 4"
      (title)="getTitle($event)"
      (fileExtension)="storeFileExtension($event)"
      (nextButtonStatus)="getNextButtonState($event)"
      [filter]="filter"
    >
    </app-file-extension-selection>
  </section>

  <section class="footer">
    <div class="buttons">
      <button class="btn btn-outline-primary -border-inverted btn-previous" (click)="previous()">Zurück</button>
      <button class="btn btn-outline-primary -border-inverted btn-next" (click)="next()" [disabled]="isDisabled">
        {{ currentStep === numberOfSteps ? 'Senden' : 'Weiter' }}
      </button>
    </div>
  </section>
</div>
